<template>
  <div class="xm-index">
    <div class="module-title">产业发展指数-细分</div>
    <div class="border-bg xm-container">
      <div class="echart-container" ref="chartRef">
      </div>
      <div class="index-cate">
        <span v-for="(item, i) in indexDataList" :key="item.code" :class="{'active': i === activeIndex}" @click="changeIndex(i)">{{item.name}}</span>
      </div>
    </div>

  </div>
</template>

<script setup>
import * as echarts from 'echarts'
import { onMounted, ref, markRaw, computed, watch } from 'vue'
import { useStore } from 'vuex'

// vuex
const store = useStore()
// 数据图chart
const chart = ref({})
// 数据图ref
const chartRef = ref()
// 指数分类数据
const indexDataList = ref([])
// 当前激活的指数
const activeIndex = ref(null)
// 数据图定时器
const chartTimer = ref(null)
// 指数数据切换定时器
const timer = ref(null)

/** 从vuex中获取指数数据 */
const indexData = computed(() => {
  return {
    index: [...store.getters.index]
  }
})

const filterIndexData = (data, id) => {
  data.value.index.forEach(item => {
    if (item.id === id) {
      indexDataList.value = item.children
    }
  })
}

/** 展示图表 */
const setChart = (data) => {
  chart.value = markRaw(echarts.init(chartRef.value))
  chart.value.clear()
  const option = {
    tooltip: {
      trigger: "axis",
    },
    grid: {
      top: 50,
      left: 50,
      bottom: 30,
      right: 50
    },
    legend: {
      itemWidth: 12,
      right: 15,
      top: 10,
      textStyle: {
        color: '#fff',
        fontSize: 11
      }
    },
    xAxis: [
      {
        type: 'category',
        data: data.xData.slice(-4),
        axisTick: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.5)'
          }
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '',
        maxInterval: 10,
        axisTick: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.5)'
          }
        },
        splitLine: {
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.5)'
          }
        },
        axisLabel: {
          show: true
        },
        min: 40,
        maxInterval: 30,
        minInterval: 20
      },
      {
        type: 'value',
        name: '',
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.5)'
          }
        },
        min: 0
      }
    ],
    series: [
      {
        name: '总指数',
        data: data.yData.slice(-4),
        type: 'bar',
        barWidth: '35%',
        barGap: '0',
        animationDelay: function (idx) {
          return idx * 500
        },
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(250, 225, 136, 1)'
              },
              {
                offset: 1,
                color: 'rgba(241, 156, 101, 1)'
              }
            ],
            globalCoord: false
          }
        },
        label: {
          normal: {
            show: true,
            position: 'top',

            fontSize: 10,
            color: '#fff',
            offset: [0, 0]
          }
        }
      },
      {
        name: '环比',
        yAxisIndex: 1,
        data: data.last.slice(-4),
        type: 'line',
        symbol: 'triangle',
        symbolSize: 15,
        symbolOffset: [0, -5],
        lineStyle: {
          color: 'rgba(255, 50, 50, 1)',
          width: 2,
          type: 'dashed'
        },
        itemStyle: {
          color: 'yellow',
          borderColor: '#fff',
          borderWidth: 1
        }
      }
    ]
  }
  chart.value.setOption(option)
  chartTimer.value && clearInterval(chartTimer.value)
  chartTimer.value = setInterval(() => {
    chart.value.clear()
    chart.value.setOption(option)
  }, 5000)
}

/** 切换指数 */
const changeIndex = (index) => {
  activeIndex.value = index
}

/** 指数切换定时器 */
const indexChangeTimer = () => {
  const len = indexDataList.value.length
  timer.value && clearInterval(timer.value)
  timer.value = setInterval(() => {
    activeIndex.value++
    activeIndex.value = activeIndex.value % len
  }, 10000)
}

onMounted(() => {
  /** 监听指数数据 */
  watch(() => indexData, (newVal, oldVal) => {
    if (newVal.value.index.length > 0) {
      filterIndexData(newVal, 541)
      activeIndex.value = 0
      indexChangeTimer()
    }
  }, { deep: true, immediate: true })

  /** 监听激活的activeIndex */
  watch(() => activeIndex, (newVal, oldVal) => {
    if (newVal.value !== null) {
      setChart(indexDataList.value[newVal.value].data)
    }
  }, { deep: true, immediate: true })
})

</script>

<style lang="scss" scoped>
.xm-index {
  margin-top: 10px;

  .xm-container {
    height: 242px;

    .echart-container {
      height: 100%;
    }
  }
}
</style>
